import React from 'react'
import Link from 'gatsby-link'
import styled, { css } from 'styled-components';

const SectionText = styled.div`
  line-height: 1.75rem;
  font-size: 1.25rem;
  font-weight: 300;
  ${'' /* opacity: 0.9; */}
  letter-spacing: 0.25px;
  & p:last-of-type {
    margin-bottom: 20px;
  }
`;

export default SectionText;



// WEBPACK FOOTER //
// ./src/components/Shared/SectionText.js